import React from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

export default function MuiButton({
  name,
  type,
  onClick,
  width,
  title,
  disabled,
  loading,
  noTextOnLoading,
  backgroundColor,
  size,
}) {
  const theme = useTheme();

  return (
    // <Typography>
    <LoadingButton
      disabled={disabled}
      variant="contained"
      type={type}
      loading={loading}
      loadingPosition={noTextOnLoading ? "" : "end"}
      title={title}
      sx={{
        backgroundColor: backgroundColor || theme.palette.primary.main,
        border: "solid 1px #eaeaea",
        borderRadius: theme.palette.buttonComponent.borderRadius.small,
        color: "#d6ebf0",
        fontSize: "14px",
        textTransform: "none",
        marginRight: "10px",
        // width: 200,
        height: "38px",
        width: width ? width : "auto",
        "&:hover": {
          backgroundColor: theme.palette.buttonComponent.hover.primary,
        },
      }}
      onClick={onClick}
    >
      {noTextOnLoading && loading ? "" : name}
    </LoadingButton>
    // </Typography>
  );
}
